<template>
  <div class="app-reverse-tariff-modal-wrapper">
    <TariffChangeBookingModal
      :show.sync = show
      :content = modalContent
      :actions = "createActions()"
      @click:reverseTariff="reverseTariff(pendingTariff)"
    >
      <template v-for="slot in possibleChildSlotsFor('Modal', pendingTariff.tariffId)" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </TariffChangeBookingModal>
  </div>
</template>
<script>

import slotProxy from '@/mixins/slotProxy'
import { mapActions, mapGetters } from 'vuex'
import TariffChangeBookingModal from '@/components/process/generic/Tariff/generic/TariffChangeBookingModal.vue'
import { durationUnit } from '@/mixins/durationUnit'
import transaction from '../../../../../../mixins/transaction'

export default {
  name: 'ReverseTariffModalWrapper',
  mixins: [
    slotProxy(),
    transaction('cancelPendingTariffChange')
  ],
  components: { TariffChangeBookingModal },
  data () {
    return {
      show: false,
      pendingTariff: [],
      contractUrl: ''
    }
  },
  computed: {
    modalContent: function () {
      return {
        title: this.pendingTariff.name,
        detailBoxes: this.createDetails(this.pendingTariff),
        slotData: this.createSlotData(this.pendingTariff),
        documentUrl: this.contractUrl ? this.contractUrl : null,
        theme: this.pendingTariff.tariffId,
        message: {
          type: this.createMessageType()
        }
      }
    },
    slotData () {
      return this.content.slotData
    },
    ...mapGetters([
      'accessToken'
    ])
  },
  methods: {
    showReverseModal (pendingTariffId, pendingTariff) {
      this.show = true
      this.pendingTariff = pendingTariff
    },
    createDetails (option) {
      const flatTexts = []
      if (option.phoneFlat === 'all') {
        flatTexts.push(option.tariffExtra?.flatTexts.phone)
      }
      if (option.smsFlat === 'all') {
        flatTexts.push(option.tariffExtra?.flatTexts.sms)
      }
      return [
        ...flatTexts || [],
        ...option.tariffExtra?.volumes || [],
        {
          primary: option.formattedBasicFee,
          secondary: option.runtime?.amount === 0 ? null : '/' + option.runtime?.amount + ' ' + durationUnit(option.runtime?.unit.toUpperCase(), option.runtime?.amount)
        }]
    },
    createSlotData (tariff) {
      return {
        name: tariff.name,
        formattedBasicFee: tariff.formattedBasicFee,
        formattedUnit: tariff.formattedUnit,
        amount: tariff.runtime?.amount
      }
    },
    formatDate (date) {
      if (date) {
        return this.$config.calendar.formatter.dateFormatter.format(new Date(date))
      }
      return null
    },
    createMessageType () {
      return 'Cancelable'
    },
    ...mapActions('bookTariff', [
      'confirmReverseTariff'
    ]),
    reverseTariff (pendingTariff) {
      const me = this
      this.confirmReverseTariff({
        tariffId: pendingTariff.tariffId
      }).then((response) => {
        if (response.data.cancelPendingTariffChange.success) {
          me.$store.commit('addMessage', { type: 'success', message: 'Tarif erfolgreich storniert' })
          me.$emit('refresh')
        }
        this.show = false
      }, () => {
        this.show = false
      }).catch((reason) => {
        me.$store.commit('addMessage', { type: 'error', message: reason })
        this.show = false
      })
    },
    createActions () {
      return [
        {
          type: 'reverseTariff',
          text: 'Stornieren'
        }
      ]
    }
  },
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    actions: {
      type: Array,
      default: () => []
    }
  }
}

</script>
